<div class="container-fluid d-flex flex-fill flex-column gap-7">
    <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center px-0">
            <span class="heading-4 fw-semi-bold">YouTube</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 px-0">
            <span class="fs-7">Customise how your post will appear on YouTube.</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-7 d-flex flex-column gap-7 ps-0">
            <div class="d-flex flex-column gap-6">
                <pp-text-area id="ytPostTitle"
                    [form]="form"
                    placeholder="Title (optional)"
                    [rows]="2" />
                <pp-text-area id="ytPostDescription"
                    [form]="form"
                    placeholder="Description (required)"
                    [rows]="6" />
                <pp-checkbox [checked]="$safeNavigationMigration(form.get('ytIncludeOddrLink')?.value)"
                    id="ytIncludeOddrLink"
                    label="Include the ODDR verified link in the post description"
                    (checkChanged)="oddrLinkSelected($event)" />
            </div>
            <ng-container [ngTemplateOutlet]="mediaUploadMadeForKids" />
            <ng-container [ngTemplateOutlet]="mediaUploadVisibility" />
            @if (displayUploadScheduleSelect) {
                <ng-container [ngTemplateOutlet]="mediaUploadSchedule" />
            }
        </div>
        <div class="col-12 col-md-5 mt-8 mt-md-0 d-flex justify-content-center justify-content-md-start">
            <pp-post-preview provider="youtube"
                [title]="$safeNavigationMigration(form.get('ytPostTitle')?.value)"
                [caption]="$safeNavigationMigration(form.get('ytPostDescription')?.value)"
                [includeOddrLink]="$safeNavigationMigration(form.get('ytIncludeOddrLink')?.value)"
                [oddrLink]="previewOddrLink"
                [thumbnailUrl]="previewThumbnailUrl"
                [mediaType]="previewMediaType"
                [imageCount]="previewImageCount" />
        </div>
    </div>
</div>
<div class="d-flex justify-content-between align-items-center mt-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <pp-button [disabled]="form.invalid"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Primary"
        (buttonClick)="submitAndGoToNextStep()">Next</pp-button>
</div>

<ng-template #uploadStatusIndicator>
    @if (uploadProgress > 0 && !uploadComplete()) {
        <div class="upload-progress-inline d-flex align-items-center gap-6">
            <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
            <div class="upload-progress-bar-track">
                <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
            </div>
        </div>
    } @else if (uploadComplete() && !processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
        </div>
    } @else if (processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Ready" src="/assets/images/icons/check-circle-solid-primary.svg" height="24px" width="24px" />
            <span class="fs-6 fw-semi-bold text-nowrap">Ready</span>
        </div>
    } @else {
        <div></div>
    }
</ng-template>

<ng-template #mediaUploadMadeForKids>
    <div class="card">
        <div class="card-body d-flex flex-column gap-7">
            <span class="fs-6 fw-semi-bold">Audience</span>
            <span class="fs-6">Is this video made for kids?</span>
            <pp-radio-button [checked]="$safeNavigationMigration(form.get('ytPostMadeForKids')?.value)"
                id="Yes"
                label="Yes, it's made for kids."
                name="mediaUploadMadeForKids"
                [value]="true"
                (optionChanged)="postMadeForKidsSelected($event)" />
            <pp-radio-button [checked]="!form.get('ytPostMadeForKids')?.value"
                id="No"
                label="No, it's not made for kids."
                name="mediaUploadMadeForKids"
                [value]="false"
                (optionChanged)="postMadeForKidsSelected($event)" />
            <pp-alert [type]="alertType.Transparent"
                message="Features like personalized ads and notifications won't be available on videos made for kids. Videos that are set as made for kids by you are more likely to be recommended alongside other kids' videos." />
        </div>
    </div>
</ng-template>

<ng-template #mediaUploadSchedule>
    <div class="card">
        <div class="card-body d-flex flex-column gap-7">
            <span class="fs-6 fw-semi-bold">Schedule</span>
            <span class="fs-6">Select a date to make your video public.</span>
            <pp-checkbox [checked]="$safeNavigationMigration(form.get('ytManualSchedule')?.value)"
                id="mediaUploadManualSchdule"
                label="Manage the visibility of this video through YouTube Studio"
                (checkChanged)="postScheduleSelected($event)" />
            <div #collapse="ngbCollapse" [ngbCollapse]="$safeNavigationMigration(form.get('ytManualSchedule')?.value)">
                <div class="d-flex flex-column gap-7">
                    <pp-date-picker id="mediaUploadScheduleDateSelect"
                        (dateSelected)="scheduledDateSelected($event)" />
                    <div class="d-flex gap-6">
                        <div class="flex-1">
                            <pp-dropdown id="mediaUploadScheduleTimeHourSelect"
                                [initialValue]="$safeNavigationMigration(form.get('ytScheduledHour')?.value)"
                                [list]="scheduledHourList"
                                (optionSelected)="scheduledTimeHourSelected($event)" />
                        </div>
                        <div class="flex-1">
                            <pp-dropdown id="mediaUploadScheduleTimeMinuteSelect"
                                [initialValue]="$safeNavigationMigration(form.get('ytScheduledMinute')?.value)"
                                [list]="scheduledMinuteList"
                                (optionSelected)="scheduledTimeMinuteSelected($event)" />
                        </div>
                        <div class="flex-1">
                            <pp-dropdown id="mediaUploadScheduleTimePeriodSelect"
                                [initialValue]="$safeNavigationMigration(form.get('ytScheduledPeriod')?.value)"
                                [list]="scheduledPeriodList"
                                (optionSelected)="scheduledTimePeriodSelected($event)" />
                        </div>
                    </div>
                    <pp-dropdown id="mediaUploadScheduleTimezoneSelect"
                        class="w-100"
                        [disabled]="true"
                        [initialValue]="$safeNavigationMigration(form.get('ytScheduledTimezone')?.value)"
                        [list]="scheduledTimezoneList"
                        (optionSelected)="scheduledTimezoneSelected($event)" />
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mediaUploadVisibility>
    <div class="card">
        <div class="card-body d-flex flex-column gap-7">
            <span class="fs-6 fw-semi-bold">Visibility</span>
            <span class="fs-6">Make your video public, unlisted or private. To schedule your video to post at a later date, select private and set the date below.</span>
            <pp-radio-button [checked]="form.get('ytPostVisibility')?.value === visibility.Private"
                id="Private"
                label="Private"
                name="mediaUploadYtVisibilitySelection"
                text="Only you and people you choose can watch your video."
                [value]="visibility.Private"
                (optionChanged)="postVisibilitySelected($event)" />
            <pp-radio-button [checked]="form.get('ytPostVisibility')?.value === visibility.Unlisted"
                id="Unlisted"
                label="Unlisted"
                name="mediaUploadYtVisibilitySelection"
                text="Anyone with the video link can watch your video."
                [value]="visibility.Unlisted"
                (optionChanged)="postVisibilitySelected($event)" />
            <pp-radio-button [checked]="form.get('ytPostVisibility')?.value === visibility.Public"
                id="Public"
                label="Public"
                name="mediaUploadYtVisibilitySelection"
                text="Everyone can watch your video."
                [value]="visibility.Public"
                (optionChanged)="postVisibilitySelected($event)" />
        </div>
    </div>
</ng-template>
